import { HttpContextToken } from '@angular/common/http';

export const SKIP_URL_MUTATION = new HttpContextToken(() => false);
